import * as yup from 'yup';

export const HIDDEN_COLUMNS = ['id', 'itemId', 'integrationKey'];

export const BEGINNING_OF_TIME = '0001-01-01';

export const EDITABLE_TYPES = {
  integer: 'integer',
  time: 'time',
  duration: 'duration',
  float: 'float',
  boolean: 'boolean',
  datetime: 'datetime',
  lookup: 'lookup',
  date: 'date',
};

export const NON_EDITABLE_TYPES = {
  id: 'id',
  string: 'string',
  colour: 'colour',
  child: 'child',
  info: 'info',
  json: 'json',
};

export const TYPES = {
  ...EDITABLE_TYPES,
  ...NON_EDITABLE_TYPES,
};

export const MODIFIER_MAP = {
  // Indeed...percent is applied to integer and float. Might have to find a better alternative.
  [TYPES.integer]: ['percent', 'number'],
  [TYPES.float]: ['percent', 'number'],
  [TYPES.datetime]: ['minutes', 'hours', 'days', 'weeks'],
  [TYPES.date]: ['days', 'weeks'],
  [TYPES.time]: ['minutes', 'hours'],
  [TYPES.duration]: ['minutes', 'hours'],
  [TYPES.boolean]: ['boolean'],
};


export const INCREASE = 'up';
export const DECREASE = 'down';
export const SET = 'set';

export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DURATION_FORMAT = TIME_FORMAT;

// A collection of format string, displayed for placeholder.
export const FORMAT_MAP = {
  [TYPES.date]: DATE_FORMAT,
  [TYPES.time]: TIME_FORMAT,
  [TYPES.datetime]: DATETIME_FORMAT,
  [TYPES.duration]: DURATION_FORMAT,
};

// Determines how values are sent.
export const VALUE_MAP = {
  [TYPES.date]: moment => moment.format(DATE_FORMAT),
  [TYPES.time]: moment => moment.format(TIME_FORMAT),
  [TYPES.duration]: moment => moment.format(DURATION_FORMAT),
  [TYPES.datetime]: moment => moment.toISOString(),
  [TYPES.integer]: number => number,
  [TYPES.float]: number => number,
  [TYPES.string]: string => string,
  [TYPES.lookup]: lookup => lookup,
  [TYPES.child]: child => child,
  [TYPES.info]: info => info,
};

// Overrides the value for display, but retains the sent value.
export const DISPLAY_VALUE_MAP = {
  [TYPES.datetime]: moment => moment.format(DATETIME_FORMAT),
};

export const DEFAULT_LIMIT = 50;
export const LIMITS = [5, 10, 25, DEFAULT_LIMIT, 100, 1000, 10000];

export const GANTT_TYPES = [
  'shift_summary',
];

export const VALIDATION_MAP = {
  [TYPES.integer]: yup.number().min(0).integer(),
  // [TYPES.time]: yup.string().matches(/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/),
  // [TYPES.duration]: yup.string().matches(/^[0-9]?[0-9]:[0-9][0-9]$/),
  // TODO: may need to include for date and time.
};
